(() => {
  if (customElements.get('rg-coupon')) return;
  class RGCoupon extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.button = this.querySelector('button');
      this.status = this.querySelector('[role="status"]');
      this.button.addEventListener('click', () => this.copy());
    }
    disconnectedCallback() { clearTimeout(this.resetTimer); }
    async copy() {
      const code = this.dataset.code;
      if (!code || this.busy) return;
      this.busy = true;
      clearTimeout(this.resetTimer);
      let copied = false;
      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(code);
        copied = true;
      } catch (_) {
        const input = document.createElement('textarea');
        input.value = code;
        input.setAttribute('readonly', '');
        input.style.cssText = 'position:fixed;left:-9999px;top:0;';
        document.body.append(input);
        input.select();
        input.setSelectionRange(0, code.length);
        try { copied = document.execCommand('copy'); } catch (_) { copied = false; }
        input.remove();
        this.button.focus({ preventScroll: true });
      }
      this.busy = false;
      if (copied) {
        const manual = this.querySelector('.rg-coupon__manual');
        if (manual) manual.hidden = true;
        this.button.textContent = 'Copied ✓';
        this.status.textContent = 'Paste at checkout.';
      } else {
        const manual = this.querySelector('.rg-coupon__manual');
        if (manual) manual.hidden = false;
        this.button.textContent = 'Try again';
        this.status.textContent = 'Select the code above to copy manually.';
      }
      this.resetTimer = setTimeout(() => {
        this.button.textContent = 'Copy code';
        this.status.textContent = '';
      }, copied ? 4000 : 10000);
    }
  }
  customElements.define('rg-coupon', RGCoupon);
})();
